import React from 'react'
import { MenuAccessPermissionsConfigs, PortalContatoPermissoesModel } from '@/domain/models'
import { Box, Loading } from '@/presentation/components'
import { ItemMenu, ItemMenuContatos, isLoadingState } from '@/presentation/pages/Home/components'
import { styles } from './styles'
import { useMediaQueries, useAuth } from '@/presentation/hooks'
import { useRecoilValue } from 'recoil'

const ITEMS_EXCLUDES = [
  'envialista',
  'telefonesuteis',
  'dadosconta',
  'seguro',
  'evento',
  'atualizaautomaticocartao',
  'indicarprospect',
  'documentosuteis'
]

const ITEMS_EXCLUDES_CONTATO = [
  ...ITEMS_EXCLUDES,
  'cartao',
  'liberacartao'
]

type MenuProps = {
  navigation: any
}

export const Menu: React.FC<MenuProps> = ({ navigation }) => {
  const { isMobile } = useMediaQueries()
  const { getClient } = useAuth()
  const isLoading = useRecoilValue(isLoadingState)

  const client = getClient()
  const isContato = client?.contato?.CodContato

  let itemsMenu = []
  if (isContato) {
    itemsMenu = client?.permissoesContato && Object
      .keys(client.permissoesContato)
      .filter((page: keyof PortalContatoPermissoesModel) => !ITEMS_EXCLUDES_CONTATO.includes(page.toLowerCase()) && !!client.permissoesContato[page])
  } else {
    itemsMenu = client?.portal && Object
      .keys(client.portal)
      .filter((page: keyof MenuAccessPermissionsConfigs) => !ITEMS_EXCLUDES.includes(page.toLowerCase()) && !!client.portal[page])
  }

  const makeItemsMenu = (): JSX.Element =>
    <Box style={{
      ...styles.content,
      ...(!isMobile && { marginTop: 36 })
    }}>
      {itemsMenu?.map((page: keyof MenuAccessPermissionsConfigs, index: number) => {
        if (!page) return null

        if (isContato) {
          return <ItemMenuContatos key={`item-menu-${index}`} page={page} navigation={navigation} />
        }
        return <ItemMenu key={`item-menu-${index}`} page={page} navigation={navigation} />
      }
      )}
    </Box>

  return (
    <Box style={styles.container} testID='home' accessibilityLabel="home">
      {isLoading || !client
        ? <Loading text='Buscando informações do cliente' />
        : makeItemsMenu()
      }
    </Box>
  )
}
